import React, { useEffect } from 'react'
import { Paper, Typography } from '@mui/material'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike'
import PaidIcon from '@mui/icons-material/Paid'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import 'aos/dist/aos.css'
import AOS from 'aos'

const tileStyle = {
  padding: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#fff',
  height: '100%',
  borderRadius: '10px',
  transition: 'all 0.3s ease-in-out',
}

const iconStyle = {
  fontSize: '3rem',
  marginBottom: '0.5rem',
}

const num = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}
const fmt = (v) => num(v).toLocaleString()

export default function SectionOne({ data }) {
  useEffect(() => {
    AOS.init({ duration: 800 })
  }, [])

  // Safe fallbacks so UI never crashes while loading
  const totalCollectedThisMonth = num(data?.totalCollectedThisMonth)
  const totalVehicles = num(data?.totalVehicles)
  const expectedThisMonth = num(data?.expectedThisMonth)
  const profit = num(data?.profit)

  const tiles = [
    {
      title: 'This Month’s Collection',
      value: `${fmt(totalCollectedThisMonth)} TZS`,
      icon: <AttachMoneyIcon style={iconStyle} />,
      background: '#1976d2',
    },
    {
      title: 'Total Vehicles',
      value: fmt(totalVehicles),
      icon: <DirectionsBikeIcon style={iconStyle} />,
      background: '#388e3c',
    },
    {
      title: 'Expected Collection',
      value: `${fmt(expectedThisMonth)} TZS`,
      icon: <PaidIcon style={iconStyle} />,
      background: '#f57c00',
    },
    {
      title: 'Profit / Loss',
      value: `${fmt(profit)} TZS`,
      icon: <TrendingUpIcon style={iconStyle} />,
      background: profit >= 0 ? '#4caf50' : '#d32f2f',
    },
  ]

  return (
    <div className="container">
      <div className="row g-3">
        {tiles.map((tile, index) => (
          <div
            key={index}
            className="col-12 col-sm-6 col-md-3"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <Paper
              elevation={4}
              style={{ ...tileStyle, backgroundColor: tile.background }}
              className="tile-hover"
            >
              {tile.icon}
              <Typography variant="h6" align="center">
                {tile.title}
              </Typography>
              <Typography variant="h5" fontWeight="bold" mt={0.5} align="center">
                {tile.value}
              </Typography>
            </Paper>
          </div>
        ))}
      </div>

      <style>
        {`
          .tile-hover:hover {
            transform: scale(1.03);
            box-shadow: 0 8px 20px rgba(0,0,0,0.2);
            cursor: pointer;
          }
        `}
      </style>
    </div>
  )
}